const styles = (theme) => ({
  searchRow: {
    display: "flex",
    direction: "column",
    "&>div": {
      flex: 1,
      width: "100%",
    },
  },
  headerText: {
    color: theme.dispatchPanelLabelValueColor,
    fontWeight: 500,
    fontSize: theme.dispatchCardTextFontSize,
    lineHeight: "16px",
    textTransform: "uppercase",
  },
  subHeaderText: {
    fontWeight: 500,
    fontSize: theme.headerTextFontSize,
    lineHeight: "16px",
    color: theme.proNumberColor,
    paddingTop: "8px",
  },
  editorContainer: {
    marginTop: "8px",
    marginBottom: "8px",
    "&.error": {
      ".mapboxgl-ctrl-geocoder--input": {
        border: "solid 1px $error-color",
      },
    },
  },
  errorMessageVisible: {
    display: "block",
    margin: "5px 0px 0px 12px",
    color: theme.ErrorMessageColor,
    fontSize: theme.textFontSize,
  },
  trailerInfo: {
    display: "flex",
    justifyContent: "center",
  },
  trailerData: {
    padding: "16px 0",
  },
  completeDropButton: {
    margin: "15px 0",
  },
});

export default styles;
